import { Controller } from "@hotwired/stimulus"

// Shows the part of the collective report form for the chosen selection mode
// (by cycle or by slaughter date).
export default class extends Controller {
  static targets = ["cycle", "date"]

  switch(event) {
    const byDate = event.target.value === "date"
    this.cycleTarget.style.display = byDate ? "none" : ""
    this.dateTarget.style.display = byDate ? "" : "none"
  }
}
